import { NOT_APPLICABLE } from 'common/constants/general';
import {
  SHEET_ALIASES_CONSTANTS,
  SHEET_TITLES_CONSTANTS,
} from 'pages/Valuations/approaches/guidelinePublicCompanies/PerformanceMetrics/common/constants/performanceMetrics';
import { countDecimalPlaces } from 'utilities';
import { EvaluateNTMRevenueGrowth, GenerateNTMRevenueGrowthExpressionParams } from './types';

const { PERFORMANCE_METRICS_SPREADSHEET_COMPANY } = SHEET_ALIASES_CONSTANTS;
const { PERFORMANCE_METRICS_SPREADSHEET_COLUMNS } = SHEET_TITLES_CONSTANTS;

export const generateNTMRevenueGrowthExpression = (params: GenerateNTMRevenueGrowthExpressionParams): string => {
  const { alphabet, rowNumber } = params;

  // Column legend (-1 excluding Company Column)
  const columnLTMRevenueLegend = alphabet[PERFORMANCE_METRICS_SPREADSHEET_COLUMNS.LTM_REVENUE - 1];
  const columnNTMRevenueLegend = alphabet[PERFORMANCE_METRICS_SPREADSHEET_COLUMNS.NTM_REVENUE - 1];

  const columnLTMRevenueKey = columnLTMRevenueLegend + rowNumber;
  const columnNTMRevenueKey = columnNTMRevenueLegend + rowNumber;

  // NTM Revenue Growth formula expression
  const NTMRevenueGrowthExpression = `=IF(OR(${columnNTMRevenueKey} == 0, ${columnLTMRevenueKey} == 0), "${NOT_APPLICABLE}", (${columnNTMRevenueKey} / ${columnLTMRevenueKey}) - 1)`;

  return NTMRevenueGrowthExpression;
};

export const evaluateNTMRevenueGrowth: EvaluateNTMRevenueGrowth = params => {
  const { alias, alphabet, rowNumber } = params;
  let { value, expr } = params;

  if (value === NOT_APPLICABLE && alias !== PERFORMANCE_METRICS_SPREADSHEET_COMPANY) {
    return {
      expr: '',
      value,
    };
  }

  // If the NTM Revenue Growth has 2 or less decimal places, we need to use the expression to display the accurate value
  // Because that means that the value is not using the new decimal places coming from the CapIQ API
  // We also need to use the expression for the company
  if (alias === PERFORMANCE_METRICS_SPREADSHEET_COMPANY || countDecimalPlaces(Number(value)) <= 2) {
    value = 0;
    expr = generateNTMRevenueGrowthExpression({ alphabet, rowNumber });
  }

  // The value is in percentage, we only need to apply the format
  if (alias !== PERFORMANCE_METRICS_SPREADSHEET_COMPANY) {
    value = Number(value ?? 0);
  }

  return { expr, value };
};
